import { createContext, useContext, useState, useRef, useCallback, Dispatch, SetStateAction } from 'react';
export const ProjectDraftContext = createContext<{initial: Record<string, any>; save: (key: string, value: any) => void} | null>(null);
export function useProjectValue<T>(key: string, fallback: T): [T, Dispatch<SetStateAction<T>>] {
  const context = useContext(ProjectDraftContext);
  const contextRef = useRef(context); contextRef.current = context;
  const [value, setValue] = useState<T>(() => context?.initial[key] ?? fallback);
  const valueRef = useRef(value); valueRef.current = value;
  const set: Dispatch<SetStateAction<T>> = useCallback(next => {
    const resolved = typeof next === 'function' ? (next as (v: T) => T)(valueRef.current) : next;
    valueRef.current = resolved;
    setValue(resolved);
    contextRef.current?.save(key, resolved);
  }, [key]);
  return [value, set];
}
